export const capitalizeFirstLetter = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const scrollToAnchor = anchorId => {
  const element = document.getElementById(anchorId);

  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};

// Hash from string
const hashString = str => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0;
    }
    return hash;
};

// Эвристика для разделения пользователей на 2 категории
export const isUserCategoryA = user => {
    const uniqueKey = user.id;
    const hash = hashString(uniqueKey);
    return hash % 2 === 0;
};
